export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/2c5fc1a35779-tooliconnumber1.jpg',
  },
  title: 'What is your order number?',
}
